import { render } from "./OverviewOffer.vue?vue&type=template&id=8634f76a&scoped=true"
import script from "./OverviewOffer.vue?vue&type=script&lang=js"
export * from "./OverviewOffer.vue?vue&type=script&lang=js"

import "./OverviewOffer.vue?vue&type=style&index=0&id=8634f76a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8634f76a"]])

export default __exports__